import React, { useState } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { BankAccountReq } from '../../pages';
import { BusinessController } from '../../controllers';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { userStore } from '../../stores';

const BankAccountReqContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.WALLETCREATEVIRTUALBUSINESSBANKACCOUNT
	);

	const createBankAccount = async () => {
		setLoading(true);
		const { status, errorMessage } =
			await BusinessController.generateBankAccount();

		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			setLoading(false);
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true);
				userStore.setReviewId(needFeedback._id);
			}
		} else {
			setLoading(false);
			closeModal();
			MimaToastUtil.error({ message: errorMessage });
		}
	};

	return (
		<BankAccountReq
			closeModal={closeModal}
			loading={loading}
			createBankAccount={createBankAccount}
		/>
	);
};

export default BankAccountReqContainer;
